import { Navigate, useRoutes } from 'react-router-dom';
import { CalendarPage } from '@/pages/app/CalendarPage';
import { TodayPage } from '@/pages/app/TodayPage';
import { MonthPlansPage } from '@/pages/app/MonthPlansPage';
import { SharedPage } from '@/pages/app/SharedPage';
import { SearchPage } from '@/pages/app/SearchPage';
import { SettingsPage } from '@/pages/app/SettingsPage';

export function AppRoutes() {
  return useRoutes([
    { index: true, element: <CalendarPage /> },
    { path: 'today', element: <TodayPage /> },
    { path: 'calendar', element: <CalendarPage /> },
    { path: 'month', element: <MonthPlansPage /> },
    { path: 'shared', element: <SharedPage /> },
    { path: 'search', element: <SearchPage /> },
    { path: 'settings', element: <SettingsPage /> },
    { path: '*', element: <Navigate to="/app" replace /> },
  ]);
}
